import React, { useState, useCallback } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { useDispatch } from 'react-redux';
import TextField from '@mui/material/TextField';
import { RowWhite, ColumnHalf, FieldTitle } from '../ui';

export const ReportInput = ({ prop, reportContents }) => {
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState('');
  const [fetchResults] = useDebouncedCallback((value) => {
    dispatch({
      type: 'FETCH_COMPUTED',
      payload: {
        value,
        prop,
        reportContents,
      },
    });
  }, 500);

  const onChange = useCallback((e) => {
    const newValue = (e.target.value || '').replace(/\D/g, '');
    setInputValue(newValue);
    fetchResults(newValue);
  }, [setInputValue, fetchResults]);

  return (
    <RowWhite
      style={{
        pageBreakBefore: prop.newPage ? 'always' : 'auto',
      }}
    >
      <ColumnHalf>
        <FieldTitle>{prop.label}</FieldTitle>
        <TextField
          variant="outlined"
          margin="dense"
          onChange={onChange}
          value={inputValue}
          placeholder={prop.placeholder}
        />
      </ColumnHalf>
    </RowWhite>
  );
};
